export default __webpack_public_path__ + "static/media/board.2f983230.png";